import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import Button from '../common/ui-components/input/Button';
import styles from '../../styles/modules/components/slot-selection.module.scss';
import Image from '../common/Image';
import Moment from 'moment';
import { dateToFormat } from '../../utils';
import { shouldShowTimeSlots } from '../../utils/selfserve';

const DateItem = ({date, index, disabled, selected, itemCategory, onSelectDate, ...rest}) => {
    let today = Moment().format('YYYY-MM-DD')
    return (
        <div key={`${date}${itemCategory}`} className={`${styles.slot_date}`} is-selected={`${selected}`} is-disabled={`${disabled}`} onClick={() => { !disabled && onSelectDate(index, date) }}>
            <span className={styles.date_weekday}>{today === date ? "TODAY" : Moment(date).format("ddd").toUpperCase()}</span>
            <span className={styles.date_day}>{Moment(date).format("D")}</span>
            <span className={styles.date_month}>{Moment(date).format("MMM")}</span>
            <span className={styles.date_availability}>{disabled ? 'Unavailable' : selected ? "Selected" : "Available"}</span>
        </div>
    );
}

const SlotPicker = (props: any) => {
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedTime, setSelectedTime] = useState('');
    const [dateHash, setDatehash] = useState(0);
    const initialScroll = useRef(true);
    const itemCategory = useMemo(() => props.isCart ? props.items[0]["category_type"] : "", [props.items]);
    const numberOfSlots = useMemo(() => Object.entries(props.slots).length - 1, [props.slots]);
    const services = useMemo(() => props.items.map((item) => item["product_type"]), [props.items]);
    const hideInSr = useMemo(() => props.isCart ? '' : styles.hide, []);
    const dateOrderMap = useMemo(() => {
        return Object.keys(props.slots).reduce((dateIndexHash, date, index) => {
            dateIndexHash[index] = date;
            return dateIndexHash;
        }, {})
    }, [props.slots]);

    const getDefaultDateHash = useCallback(() => {
        let initialDateHash = { date: '', hash: 0 };
        Object.entries(props.slots).some((slotData: any, slotArrayIndex) => {
            if (slotData[1]['isTimeAvailable']) {
                initialDateHash.date = slotData[0];
                initialDateHash.hash = slotArrayIndex;
                return true;
            }
            return false;
        });
        return initialDateHash;
    }, [props.slots]);

    const scrollToEnd = (selectedPosition) => {
        const scrollElement = document.getElementById(`${itemCategory}DateSelection`);
        const timeCarousel = document.getElementById(`${itemCategory}timeSlotsCarousel`); 
        const timeCarouselWidth = Number(timeCarousel?.offsetWidth);
        let scrollBarWidth = Number(scrollElement?.offsetWidth);
        let tempPos = 0;
        if (window.innerWidth > 992) {
            tempPos = selectedPosition < 4 ? 0 : Math.floor(selectedPosition / 4) * (scrollBarWidth);
        } else {
            tempPos = selectedPosition * 134;
        }
        timeCarousel?.scroll(timeCarouselWidth * selectedPosition, 0)
        
        scrollElement?.scroll(tempPos, 0);
    };

    const onClickScroll = useCallback((direction) => {
        if (props.isDisabled) { return };
        const tempDateHash = Math.abs((dateHash + direction) % (numberOfSlots + 1));
        onSelectDate(tempDateHash, dateOrderMap[tempDateHash]);
    }, [dateHash, numberOfSlots, dateOrderMap]);

    const onSelectDate = useCallback((hashKey, date) => {
        if (props.isDisabled) { return };
        initialScroll.current = false;
        setSelectedDate(date);
        setDatehash(hashKey);
        setSelectedTime('');
    }, []);

    const onSelectTime = useCallback((time) => {
        if (props.isDisabled) { return };
        setSelectedTime(time);
    }, []);

    window.addEventListener('resize', () => {
        scrollToEnd(dateHash);
    });

    useEffect(() => {
        let defaultDateHash = getDefaultDateHash();
        if (!props.slotData[itemCategory] || props.slotData[itemCategory]['preferred_date_1'] === "") {
            onSelectDate(defaultDateHash.hash, defaultDateHash.date)
            props.updateSlotData({ ...props.slotData, [itemCategory]: { services: services, date: defaultDateHash.date, time: '' } })
        } else {
            setSelectedDate(props.slotData[itemCategory]['preferred_date_1']);
            setSelectedTime(props.slotData[itemCategory]['preferred_time_slot_1']);
        }
    }, []);

    useEffect(() => {
        let defaultDateHash = getDefaultDateHash();
        onSelectDate(defaultDateHash.hash, defaultDateHash.date)
    }, [props.pinCode]);

    useEffect(() => {
        if (selectedDate === "" || dateOrderMap[dateHash] !== selectedDate) {
            let defaultDateHash = getDefaultDateHash();
            onSelectDate(defaultDateHash.hash, defaultDateHash.date)
        }
    }, [props.slots]);

    useEffect(() => {
        scrollToEnd(dateHash);
    }, [dateHash])

    useEffect(() => {
        props.updateSlotData({ ...props.slotData, [itemCategory]: { services: services, preferred_date_1: selectedDate, preferred_date_2: selectedDate, preferred_time_slot_1: selectedTime, preferred_time_slot_2: selectedTime } })
    }, [selectedDate, selectedTime]);

    const formatDisplayDate = useCallback((date): string => {
        let formattedDate = date.length < 10 ? dateToFormat(date) : date
        let today = Moment().format('YYYY-MM-DD')
        if (today === formattedDate) {
            return 'Today, ' + Moment(formattedDate).format("D MMM");
        }
        let tomorrow = Moment().add(1,'days').format('YYYY-MM-DD')
        return tomorrow === formattedDate ? 'Tomorrow, ' + Moment(formattedDate).format("D MMM") : Moment(formattedDate).format("dddd, D MMM");
    }, []);

    return (
        <div className={`${styles.slot_selection_container} ${props.isDisabled && props.isDateAvailable ? styles.slot_container_disabled : ''}`} id="slotpickercontainer">
            <div className={`${hideInSr} ${styles.category_title}`}>
                <Image src={"/static/images/tool1.svg"} alt="devices-renewals" height='24' width='24' />
                <span>{itemCategory}</span>
            </div>
            <div className={`${hideInSr} ${styles.added_services_container}`}>
                {
                    props.items.map((item) => <div className={styles.added_services}>{`${item.display_title} `}<span className={styles.temp}>X</span> {`${item.quantity}`}<p>{item.category}</p></div>)
                }
            </div>
            <div className={`${(props.isDateAvailable || props.isAgent) ? styles.hide : styles.no_slots}`}>
                <div className={styles.no_slots_warning}>
                    <div className={styles.warning_icon}><Image src={"/static/images/warning.png"} alt="devices-renewals" height='26' width='26' /></div>
                    <span>
                            Sorry, we do not have any available slots at the moment. Please check back later or contact our customer care team at 99205 99206.
                    </span>
                </div>
                <Button onClick={() => { props.removeCateory(itemCategory) }} text={props.items.length === 1 ? "Remove Item" : "Remove Items"} className={`${styles.remove_button} ${hideInSr}`}></Button>
            </div>
            <div className={`${props.isDateAvailable ? '' : styles.hide} ${styles.slot_picker} ${props.isCart ? styles.cart_slot_picker : styles.sr_slot_picker} ${props.isAgent ? styles.hide : ""}`}>
                <button className={dateHash != 0 ? `${styles.scroll_button} ${styles.left_scroll}` : styles.hide} onClick={() => onClickScroll(-1)}><Image src={"/static/images/angleLeft.png"} className={styles.scroll_icon} height='10' width='6' /></button>
                <button className={`${styles.scroll_button} ${styles.right_scroll} ${dateHash != numberOfSlots ? "" : styles.hide}`} disabled={false} onClick={() => onClickScroll(1)}><Image src={"/static/images/angleRight1.png"} className={styles.scroll_icon} height='10' width='8' /></button>
                <div className={styles.dates_container} id={`${itemCategory}DateSelection`} onScroll={(e) => { if (props.isDisabled) { e.preventDefault() } }}>
                    {
                        Object.entries(props.slots).map((date: any, elementIndex) => (
                            <DateItem
                                key={date[0]}
                                index={elementIndex}
                                date={date[0]}
                                onSelectDate={onSelectDate}
                                disabled={!props.slots[date[0]]['isTimeAvailable']}
                                selected={selectedDate === date[0]}
                                itemCategory={itemCategory}
                                />
                            )
                        )
                    }
                </div>
                {shouldShowTimeSlots() ? <div className={styles.time_carousel} id={`${itemCategory}timeSlotsCarousel`}>
                    {

                        Object.entries(props.slots).map((timeSlots) => <div className={styles.time_banner} scrolls-easing="ease-out">
                            <div className={styles.selected_date_display}>{formatDisplayDate(timeSlots[0])}</div>
                            <div className={props.slots[timeSlots[0]]?.['isTimeAvailable'] ? styles.time_container : styles.hide}>
                                {
                                    props.slots[timeSlots[0]]?.['timings'].map((time) => time.is_available && <div className={`${selectedTime === time.slot_time ? styles.selected_time : ''} ${styles.slot_time}`} onClick={() => onSelectTime(time.slot_time)}>{time.slot_time}</div>)
                                }
                            </div>
                            <div className={props.slots[timeSlots[0]]?.['isTimeAvailable'] ? styles.hide : styles.time_container}>
                                    No Slot Available
                                </div>
                        </div>)
                    }
                </div> : null}
            </div>
            <div className={`${props.isDateAvailable && !props.isnonServiceablePincode && props.isAgent ? styles.agent_view : styles.hide}`}>
                Available
            </div>
            <div className={`${props.isnonServiceablePincode && props.isAgent ? styles.agent_view : styles.hide} ${styles.not_available}`}>
                No Slot Available
            </div>
        </div>
    )
}

export default SlotPicker;